import React from 'react';
import { Box, Typography, Divider, AppBar } from '@mui/material';
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

import CalendarForm from './CalendarForm';
import { getPriceColors } from './prices';

const LegendItem = ({ color, label }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', marginRight: 1.5, color: 'inherit' }}>
    <Box sx={{ width: 20, height: 20, backgroundColor: color, borderRadius: '50%', marginRight: 0.5, border: color === '#ffffff' ? '1px solid rgba(0,0,0,0.3)' : 'none' }} />
    <Typography color="inherit">{label}</Typography>
  </Box>
);

const CalendarHeader = props => {
  const {
    startDate,
    endDate,
    onStartDate,
    onEndDate
  } = props;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const appBarStyle = {
    width: '100%',
    backgroundColor: theme.palette.brand?.green || '#003a27',
    color: '#fff',
    boxShadow: 'none',
    zIndex: (theme.zIndex.appBar || 1100) - 1,
    borderRadius: 0
  }

  let paddingX = { xs: '12px', sm: '24px', md: '40px' };
  let paddingY = { xs: '8px', sm: '12px', md: '16px' };

  let boxStyle = {
    paddingLeft: paddingX,
    paddingRight: paddingX,
    paddingTop: paddingY,
    paddingBottom: '1rem',
    display: 'flex',
    flexDirection: 'column',
    color: '#fff'
  }

  const priceColors = getPriceColors(theme);
  const brand = theme.palette.brand || {};
  const legendItems = [
    { label: 'Weekdays', color: priceColors.low },
    { label: 'Weekends', color: brand.gold || priceColors.medium },
    { label: 'Holidays', color: brand.red || priceColors.veryHigh }
  ];

  return (
    <>
      <AppBar position="sticky" sx={appBarStyle} elevation={0}>
	<Box sx={{ ...boxStyle }}>
	  <CalendarForm {...{ startDate, endDate, onStartDate, onEndDate }} />
	</Box>
      </AppBar>
      <div style={{height: '1rem'}} />
      <Box>
        <b style={{marginRight: '1rem'}}>Price Guide</b>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'row', margin: '0.3rem 0', flexWrap: 'wrap' }}>
	{legendItems.map(item => (
	  <LegendItem key={item.label} color={item.color} label={item.label} />
	))}
      </Box>
      <span><i>* Shipping is not included</i></span>
      <Divider spacing={0.5} />
    </>
  );
}

export default CalendarHeader;
